import HelpdeskPageRouteView from './pages/HelpdeskPageRouteView.vue';
import TicketRegisterPage from './pages/TicketRegisterPage.vue';
import TicketViewPage from './pages/TicketViewPage.vue';
import SlaMonitoringDashboard from './pages/SlaMonitoringDashboard.vue';
import KanbanDashboard from './pages/KanbanDashboard.vue';

const helpdeskRoutes = [
  {
    path: 'helpdesk',
    name: 'helpdesk_index',
    component: HelpdeskPageRouteView,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
  {
    path: 'helpdesk/ticket/new',
    name: 'helpdesk_ticket_register',
    component: TicketRegisterPage,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
  {
    path: 'helpdesk/ticket/:id',
    name: 'helpdesk_ticket_view',
    component: TicketViewPage,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
  {
    path: 'helpdesk/sla-monitoring',
    name: 'helpdesk_sla_monitoring',
    component: SlaMonitoringDashboard,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
  {
    path: 'helpdesk/kanban',
    name: 'helpdesk_kanban',
    component: KanbanDashboard,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];

export default {
  routes: helpdeskRoutes,
};
